import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { url } from '../../constants/url'
import { toast } from 'react-toastify'
import { useAuth } from '../../Context/UserContext'
import './Feedback.css'

const Feedback = ({setOpenFeedbackForm}) => {

    const [feedbackEmail, setFeedbackEmail] = useState('')
    const [feedbackEmailError, setFeedbackEmailError] = useState('')

    const { logout } = useAuth('')

    const handleFeedbackForm = async () => {

        if (feedbackEmail === '') {
            setFeedbackEmailError("Email required")
            return
        }

        try {
            const response = await fetch(`${url}/sendfeedbackform`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    feedbackEmail
                })
            })
            if (response.ok) {
                toast.success('Feedback form successfully...', {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });
                setFeedbackEmail('')
                setFeedbackEmailError('')
                return
            }

            if (response.status === 400) {
                toast.error("Bad Request", {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });

            }
            if (response.status === 440) {
                logout()
                toast.error("User logout due to inactivity", {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });

            }

            return response

        } catch (error) {
            console.log(error)
            toast.error(error.response.data.message, {
                position: "top-center",
                autoClose: 5000,
                pauseOnHover: false,
            });
            // setDisableEmployeebutton(false)
        }
    }

    return (
        <div className='wrap_register_user_content'>
            <div className='register_user'>
                <div className='wrap_page_button'>
                    <div className='wrap_reg_heading'>
                        <h1>Feedback Form</h1>
                        <button onClick={() => { setOpenFeedbackForm(false) }}><FontAwesomeIcon icon={faXmark} /></button>
                    </div>

                    <p>Please provide the client’s email address so we can send the feedback form directly to them.</p>
                    <div className='wrap_employee_inputs'>
                        <div className='inputs'>
                            <label>Company Email</label>
                            <input type='text'
                                placeholder='Company Email'
                                value={feedbackEmail}
                                onChange={(e) => {
                                    setFeedbackEmail(e.target.value)
                                    setFeedbackEmailError('')
                                }} />
                            {feedbackEmailError && <p>{feedbackEmailError}</p>}
                        </div>
                        <div className='inputs'>
                            <button onClick={handleFeedbackForm}>Send Feedback Form</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Feedback
